import * as React from 'react';

/** React.lazy caches a rejected import, so one dropped chunk request (or a chunk a deploy replaced) is a white page. */
export async function loadWithRetry<T>(load: () => Promise<T>, attempts = 3, delayMs = 200): Promise<T> {
	let lastError: unknown;
	for (let attempt = 0; attempt < attempts; attempt++) {
		try {
			return await load();
		} catch (error) {
			lastError = error;
			if (attempt === attempts - 1) {
				break;
			}
			await new Promise(resolve => setTimeout(resolve, delayMs * (attempt + 1)));
		}
	}
	throw lastError;
}

export function lazyWithRetry<T extends React.ComponentType<object>>(
	load: () => Promise<{ default: T }>,
	attempts = 3
): React.LazyExoticComponent<T> {
	return React.lazy(() => loadWithRetry(load, attempts));
}
